import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { API_TAGS } from '@/shared/api';

import { createAiAgentChat, fetchAiAgentChat, fetchAiAgentChats, fetchAiAgentMessages } from './api';

export const aiAgentChatKeys = {
  all: [API_TAGS.AI_AGENT_CHATS] as const,
  lists: () => [...aiAgentChatKeys.all, 'list'] as const,
  list: (params?: { limit?: number; offset?: number }) => [...aiAgentChatKeys.lists(), { ...params }] as const,
  details: () => [...aiAgentChatKeys.all, 'detail'] as const,
  detail: (id: number) => [...aiAgentChatKeys.details(), id] as const,
  messages: (chatId: number) => [...aiAgentChatKeys.all, chatId, 'messages'] as const,
};

export const useAiAgentChats = (params?: { limit?: number; offset?: number }) => {
  return useQuery({
    queryKey: aiAgentChatKeys.list(params),
    queryFn: () => fetchAiAgentChats(params),
  });
};

export const useAiAgentChat = (id: number) => {
  return useQuery({
    queryKey: aiAgentChatKeys.detail(id),
    queryFn: () => fetchAiAgentChat(id),
    enabled: id > 0,
  });
};

export const useAiAgentMessages = (chatId: number) => {
  return useQuery({
    queryKey: aiAgentChatKeys.messages(chatId),
    queryFn: () => fetchAiAgentMessages(chatId),
    enabled: chatId > 0,
  });
};

export const useCreateAiAgentChat = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createAiAgentChat,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiAgentChatKeys.lists() });
    },
  });
};
